<template>
  <div id="contenedor-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="usuarios"
      :items-per-page="20">
      <template v-slot:[`item.funcionario.esSupervisor`]="{ item }">
        <v-icon
          v-if="getEsSupervisor(item)"
          class="secondary--text">
          {{getEsSupervisor(item)}}
        </v-icon>
      </template>
      <template v-slot:[`item.funcionario.nombre`]="{ item }">
         {{ getUsuarioNombre(item) }}
      </template>
      <template v-slot:[`item.estatus`]="{ item }">
        <v-switch
          v-model="item.estatus"
          :true-value="1"
          :false-value="2"
          inset
          @change="preCambiarEstatus(item)">
        </v-switch>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones
          :usuario="item">
        </opciones>
      </template>
    </v-data-table>
    <v-dialog
      v-if="usuarioSeleccionado"
      v-model="editarUsuarioDialog"
      width="600"
      persistent>
      <v-card>
        <v-card-title>Cambiar Estatus Usuario</v-card-title>
        <v-card-text>
          <custom-text-area
            cols="12"
            v-model="comentarios"
            label="Comentarios"
            autoGrow>
          </custom-text-area>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="cerrarEditarUsuarioDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="cambiarEstatus">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ACTUALIZAR_ESTATUS_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/actualizarEstatusUsuario.gql';
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import Opciones from './Opciones.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';

export default {
  name: 'ListadoDesktop',
  components: {
    Opciones,
    CustomTextArea,
  },
  props: {
    usuarios: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Es Supervisor',
          value: 'funcionario.esSupervisor',
          sortable: false,
          width: '1%',
        },
        { text: 'Nombre', value: 'funcionario.nombre', sortable: true },
        { text: 'Correo', value: 'correoElectronico', sortable: true },
        { text: 'Estatus', value: 'estatus', sortable: false },
        { text: 'Comentarios', value: 'comentarios', sortable: false },
        {
          text: '', align: 'end', value: 'acciones', sortable: false,
        },
      ],
      usuarioSeleccionado: null,
      editarUsuarioDialog: false,
      comentarios: null,
    };
  },
  methods: {
    getUsuarioNombre(usuario) {
      if (usuario.funcionario?.nombre) { return usuario.funcionario.nombre; }
      if (usuario.cliente?.nombre) { return usuario.cliente.nombre; }
      if (usuario.contratista?.nombreRazonSocial) { return usuario.contratista.nombreRazonSocial; }
      return '';
    },
    getEsSupervisor(usuario) {
      let iconUsuario = '';

      if (usuario?.funcionario?.esSupervisor) {
        iconUsuario = 'fa-hard-hat';
      }
      if (usuario?.funcionario?.esSupervisor === false) {
        iconUsuario = 'mdi-briefcase-check';
      }
      if (usuario?.cliente?.id) {
        iconUsuario = 'mdi-account-star';
      }
      if (usuario?.contratista?.id) {
        iconUsuario = 'mdi-shovel';
      }
      return iconUsuario;
    },

    cerrarEditarUsuarioDialog() {
      this.editarUsuarioDialog = true;
      this.comentarios = null;
      this.usuarioSeleccionado = null;
    },
    preCambiarEstatus(usuarioEditar) {
      this.usuarioSeleccionado = usuarioEditar;
      this.editarUsuarioDialog = true;
    },
    cambiarEstatus() {
      const { id, estatus } = this.usuarioSeleccionado;
      const usuario = {
        estatus: !estatus ? 2 : estatus,
        comentarios: this.comentarios,
      };
      this.$apollo
        .mutate({
          mutation: ACTUALIZAR_ESTATUS_USUARIO,
          variables: { id, usuario },
          update: (cache, { data: { actualizarEstatusUsuario } }) => {
            const data = cache.readQuery({ query: USUARIOS });
            const { usuarios } = data;
            const index = usuarios.findIndex((item) => item.id === id);
            usuarios.splice(index, 1, actualizarEstatusUsuario);
            cache.writeQuery({ query: USUARIOS, data });
            this.cerrarEditarUsuarioDialog();
          },
        });
    },
  },
};
</script>

<style lang="scss">

</style>
